<template>
<transition name="fade">
  <div>
    <Modal
      :value="state"
      width="300"
      @on-cancel="cancel"
      :closable="config.closable"
      :mask-closable="false"
      :styles="style"
      class-name="flex-modal"
    >
      <p slot="header" style="color:#f60;text-align:center;border-bottom:none;"></p>
      <div style="text-align:center;font-size:18px;">
        <Icon type="ios-information-circle" color="#f60" size="24" />
        <p v-if="code == 40001">您还未登录或登录已过期，请登录后使用！</p>
        <p v-if="code !== 40001" v-html="message"></p>
      </div>
      <div slot="footer">
        <Button class="app-btn"
          type="success"
          style="background-image: linear-gradient(to right, #6c35de, #a364ff);"
          size="large"
          long
          @click="ok"
        >
          <span v-if="code === 40001">{{ $t('login') }}</span>
          <span v-if="code === 40002 || code === 30001">{{ $t('buy') }}</span>
          <span v-if="code === 0">{{ $t('ISee') }}</span>
        </Button>
      </div>
    </Modal>
  </div>
  </transition>
</template>

<script>
export default {
  name: "modalComponent",
  props: {
    state: {
      type: Boolean,
      default: false
    },
    code: {
      type: Number,
      default: 40001
    },
    message: {
      type: String,
      default: 'test'
    }
  },
  data() {
    return {
      style: {
        top: 'unset',
        width: '300px!important'
      },
      config: {
        closable: true
      }
    }
  },
  methods: {
    ok() {
      if (this.code === 40001) {
        this.$utils.login()
      } else if (this.code === 40002 || this.code === 30001) {
        window.location.href = this.$config.myTraffic
      } else {
        this.cancel()
      }
    },
    cancel() {
      this.$emit('update:state', false)  // 通知父组件更新 state
      this.$emit('cancel')
    },
    openView(code, message) {
      this.$emit('update:state', true)
      this.$emit('update:code', code)
      this.$emit('update:message', message)
    }
  }
}
</script>


<style scoped>
.flex-modal{
    display: flex;
    justify-content: center;
    align-items: center;
}

.modal-logo {
    display: flex;
    margin: 0 auto;
}

.modal-logo img{
    width: 120px;
}
.modal-logo .proof {
    margin-left: 12px;
}

.app-btn{
  background-image: linear-gradient(to right, #6c35de, #a364ff);
  border: none;
  width: 100%;
  height: 40px;
  border-radius: 10px;
  font-size: 18px;
  font-weight: 600;
} 
.ivu-modal-header,
.ivu-modal-footer {
    border: none !important;
}
</style>